import React from 'react'

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            LektApi Dashboard
          </h1>
          <p className="text-gray-600 mb-6">
            Welcome to the LektApi document intelligence platform. 
            This dashboard will be enhanced with full functionality soon.
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg">
              <h2 className="text-xl font-semibold text-blue-900 mb-2">
                Document Intelligence
              </h2>
              <p className="text-blue-700">
                OCR, data extraction, and document analysis capabilities
              </p>
            </div>
            
            <div className="bg-green-50 p-6 rounded-lg">
              <h2 className="text-xl font-semibold text-green-900 mb-2">
                Data Transformation
              </h2>
              <p className="text-green-700">
                JSON processing, text normalization, and data validation
              </p>
            </div>
            
            <div className="bg-purple-50 p-6 rounded-lg">
              <h2 className="text-xl font-semibold text-purple-900 mb-2">
                Content Creation
              </h2>
              <p className="text-purple-700">
                AI-powered text generation and image creation
              </p>
            </div>
          </div>
          
          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600">
              API Health: <span className="text-green-600 font-semibold">Online</span>
            </p>
            <p className="text-sm text-gray-600 mt-1">
              API Endpoint: <code className="bg-gray-200 px-1 rounded">/api/v1</code>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
